module.exports = __webpack_public_path__ + "static/media/map-marker-icon.8fc7dfa7.png";